import 'whatwg-fetch';
import qs from 'qs';
import { logError } from 'client/javascript/util/logger';

export async function get(url, { params = {} }) {
  const queryString = qs.stringify(params);
  const fullURL = queryString ? `${url}?${queryString}` : url;

  try {
    const response = await fetch(fullURL);
    const data = await response.json();
    return { data };
  } catch (err) {
    logError(`Failed to fetch URL: ${fullURL}`, err);
    return null;
  }
}
